import authenticate from '@/middleware/authenticate'
import store from '@/store'

export default [
  {
    path: '/pay-payroll-item-companies',
    name: 'pay-payroll-item-company',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/pay-payroll-item-company'),
    beforeEnter: async (to, from, next) => {
      await Promise.all([
        store.dispatch('hr/payPayrollItemCompany/fetchCompanies'),
        store.dispatch('hr/payPayrollItemCompany/fetchPayrollItemTypes')
      ])

      next()
    }
  }
]
